import React from "react";

import { getStripeDate } from "../../../../utils/format-stripe-date";
import { formatNumber } from "../../../../utils/format-sub";
import SvgIcon from "../../../../parts/SvgIcon";

const PayoutsTable = ({ handleSort, payouts, sorting }) => {
  const sortedPayouts = sorting === "desc" ? payouts : [...payouts].reverse();

  return (
    <div className="payouts-history">
      <header>
        <h3 className="title">Payouts history</h3>
      </header>
      <section role="table-wrapper" data-borders-inside>
        <table role="report-table">
          <thead>
            <tr>
              <th>Amount</th>
              <th>
                <div className="flex gap-2">
                  Created
                  <SvgIcon
                    src="/img/svg/up_down_arrows.svg"
                    onClickFn={handleSort}
                  />
                </div>
              </th>

              <th>Arrival</th>
            </tr>
          </thead>
          <tbody>
            {sortedPayouts.map(
              ({ amount, created, arrival_date, currency }, idx) => {
                const { day, month, year } = getStripeDate(created);
                const arrival = getStripeDate(arrival_date);
                return (
                  <tr key={idx}>
                    <td className="amount">
                      <div className="flex items-center h-[32px]">
                        {formatNumber(amount, currency)}
                      </div>
                    </td>
                    <td>{`${month} ${day}, ${year}`}</td>
                    <td>{`${arrival.month} ${arrival.day}, ${arrival.year}`}</td>
                  </tr>
                );
              }
            )}
          </tbody>
        </table>
      </section>
    </div>
  );
};

export default React.memo(PayoutsTable);
